<template>
	<div style="background-color: #F5F5F5;">
		<div v-if="totalTimeOvO" style="z-index: 8999; position: fixed;top: 0;width: 100%;height: 100%;display: flex;flex-direction: column;  justify-content: center;align-items: center;background-color: rgba(1,1,1,0.2)">
			<div style="position: relative; width: 500px;height: 600px;background-color: white;border-radius: 10px;box-shadow: 0 0.125rem 0.1625rem 0.1125rem rgba(221, 221, 221, 0.9);border: 1px solid rgba(221, 221, 221, 0.9);">
				<div style="display: flex;justify-content: center;color: black;font-size: 20px;font-weight: bold;margin-top: 10px;">仪器使用须知</div>
				<div style="width: 100%;overflow-y: scroll;height: 83%;">
					<!-- <div v-for="i in 1000">1111111111</div> -->
					<div v-html="InstrumentDetailedData.useIntro" style="margin: 0 15px;margin-top: 15px;">
						
					</div>
				</div>
				
				<div style="width: 100%;height: 50px;color: white;display: flex;justify-content: center;align-items: center;position: absolute;bottom: 0;">
					<a-button @click="totalEvent(InstrumentDetailedData)" :disabled="totalTimeBtn==true?false:true" type="primary" style="width: 8.75rem;height: 2.5rem;">
						 {{content}}
					</a-button>
				</div>
			</div>
		</div>
		<div style="width: 75rem;height: 31.25rem;margin:  0 auto;background-color: white;">
			<a-row>
				<a-col :span="8" >
					<div v-if="InstrumentDetailedData.sn!=0||InstrumentDetailedData.androidDeviceSn!=null">
						<a-tag
						color="grey"
						v-if="InstrumentDetailedData.state=='断开连接'"
							style="min-width: 1.5rem;height: 1.125rem;display: flex;justify-content: center;align-items: center;position: absolute;left: 3.1rem;top: 3.2rem;">
							<!-- <p style="font-size: 1px;color: white;padding: 0 3px;">{{InstrumentDetailedData.state==0?'空闲':InstrumentDetailedData.state==1?'运行中':InstrumentDetailedData.state==2?'维修中':InstrumentDetailedData.state==3?'故障':InstrumentDetailedData.state==4?'断开链接':''}}</p> -->
							<p style="font-size: 1px;padding: 0 3px;">{{InstrumentDetailedData.state}}</p>
						</a-tag>
						<a-tag color="#87d068" v-else-if="InstrumentDetailedData.state=='空闲'"
							style="min-width: 1.5rem;height: 1.125rem;display: flex;justify-content: center;align-items: center;position: absolute;left: 3.1rem;top: 3.2rem;">
							<!-- <p style="font-size: 1px;color: white;padding: 0 3px;">{{InstrumentDetailedData.state==0?'空闲':InstrumentDetailedData.state==1?'运行中':InstrumentDetailedData.state==2?'维修中':InstrumentDetailedData.state==3?'故障':InstrumentDetailedData.state==4?'断开链接':''}}</p> -->
							<p style="font-size: 1px;padding: 0 3px;">{{InstrumentDetailedData.state}}</p>
						</a-tag>
						<a-tag color="#2db7f5" v-else-if="InstrumentDetailedData.state=='运行中'"
							style="min-width: 1.5rem;height: 1.125rem;display: flex;justify-content: center;align-items: center;position: absolute;left: 3.1rem;top: 3.2rem;">
							<!-- <p style="font-size: 1px;color: white;padding: 0 3px;">{{InstrumentDetailedData.state==0?'空闲':InstrumentDetailedData.state==1?'运行中':InstrumentDetailedData.state==2?'维修中':InstrumentDetailedData.state==3?'故障':InstrumentDetailedData.state==4?'断开链接':''}}</p> -->
							<p style="font-size: 1px;padding: 0 3px;">{{InstrumentDetailedData.state}}</p>
						</a-tag>
						<a-tag color="#f50" v-else-if="InstrumentDetailedData.state=='故障'"
							style="min-width: 1.5rem;height: 1.125rem;display: flex;justify-content: center;align-items: center;position: absolute;left: 3.1rem;top: 3.2rem;">
							<!-- <p style="font-size: 1px;color: white;padding: 0 3px;">{{InstrumentDetailedData.state==0?'空闲':InstrumentDetailedData.state==1?'运行中':InstrumentDetailedData.state==2?'维修中':InstrumentDetailedData.state==3?'故障':InstrumentDetailedData.state==4?'断开链接':''}}</p> -->
							<p style="font-size: 1px;padding: 0 3px;">{{InstrumentDetailedData.state}}</p>
						</a-tag>
						<a-tag color="#F27900" v-else-if="InstrumentDetailedData.state=='维修中'"
							style="min-width: 1.5rem;height: 1.125rem;display: flex;justify-content: center;align-items: center;position: absolute;left: 3.1rem;top: 3.2rem;">
							<!-- <p style="font-size: 1px;color: white;padding: 0 3px;">{{InstrumentDetailedData.state==0?'空闲':InstrumentDetailedData.state==1?'运行中':InstrumentDetailedData.state==2?'维修中':InstrumentDetailedData.state==3?'故障':InstrumentDetailedData.state==4?'断开链接':''}}</p> -->
							<p style="font-size: 1px;padding: 0 3px;">{{InstrumentDetailedData.state}}</p>
						</a-tag>
						<a-tag v-else
							style="min-width: 1.5rem;height: 1.125rem;display: flex;justify-content: center;align-items: center;position: absolute;left: 3.1rem;top: 3.2rem;">
							<!-- <p style="font-size: 1px;color: white;padding: 0 3px;">{{InstrumentDetailedData.state==0?'空闲':InstrumentDetailedData.state==1?'运行中':InstrumentDetailedData.state==2?'维修中':InstrumentDetailedData.state==3?'故障':InstrumentDetailedData.state==4?'断开链接':''}}</p> -->
							<p style="font-size: 1px;color: black;padding: 0 3px;">{{InstrumentDetailedData.state}}</p>
						</a-tag>
					</div>
					
					<img :class="InstrumentDetailedData.state=='故障'?'darks':''" v-if="InstrumentDetailedData.picture!='http://wdrm-admin.zkshare.com'" style="width: 22.5rem;height: 22.5rem;margin: 2.5rem;"
						:src="InstrumentDetailedData.picture">
						<img v-if="InstrumentDetailedData.picture=='http://wdrm-admin.zkshare.com'" style="width: 22.5rem;height: 22.5rem;margin: 2.5rem;"
							src="../../assets/images/instrument-default.jpg">
					<div style="display: flex; justify-content: center;font-size: 0.875rem;color: rgba(0, 0, 0, 0.45);
">						<div style="display: flex;align-items: center;margin-top: -25px;margin-left: 8px;">
					<img src="../../assets/images/Vectors.png" style="margin-right: 15px;">
					<div style="font-size: 14px;">{{InstrumentDetailedData.instrumentName}}</div>
					
</div>
						
						
						
					</div>
				</a-col>
				<a-col :span="12" :offset="1">
					<p style="margin-top: 2.5rem;font-size: 24px;color: rgba(0, 0, 0, 0.85);">{{InstrumentDetailedData.instrumentName}}</p>
					<div style="width: 44.3125rem;height: 0.0625rem;background-color: rgba(0, 0, 0, 0.1);">
					</div>
					<a-col :span="12">
						<p style="font-size: 1rem;color: rgba(0, 0, 0, 0.85);margin-top: 1.875rem;">基本信息</p>
						<div style="display: flex;">
							<p @click="ceshi()">型号：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.model}}</p>
						</div>
						<div style="display: flex;">
							<p>厂家：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.company}}</p>
						</div>
						<div style="display: flex;">
							<p>所属平台：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.labName}}</p>
						</div>
						<div style="display: flex;">
							<p>存放位置：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.instrumentLocationName}}</p>
						</div>
						<div style="display: flex;">
							<p>管理员：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.realName}}</p>
						</div>
						<div style="display: flex;" v-if="InstrumentDetailedData.agent">
							<p>负责人：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.contactName}}</p>
						</div>
						<div style="display: flex;">
							<p>电话：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.contactPhone}}</p>
						</div>
						<div style="display: flex;">
							<p>邮箱：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.contactEmail}}</p>
						</div>
						
						<div style="display: flex;">
							<p style="width: 75px;">说明文档：</p>
							
							<p   @click="downFile(item)" style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 0px;color: #1890FF;cursor: pointer;" v-for="item in InstrumentDetailedData.documentPathList">{{item.split('_')[1]}}</p>
						</div>
					</a-col>
					<a-col :span="12">
						<p style="font-size: 1rem;color: rgba(0, 0, 0, 0.85);margin-top: 1.875rem;">预约须知</p>
						<div v-show="InstrumentDetailedData.charges.length>1" style="display: flex;">
							<p>上机计费：</p>
							<a-popover>
							    <template slot="content">
	
								  <div v-for="(item,i) in InstrumentDetailedData.charges">
									  <p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;" >{{item.priceDeicTime}}   <span style="color: red;">￥{{item.price.toFixed(2)}}</span> 元/min</p>
								  </div>
							     
							    </template>
							  
							     <span style="cursor:pointer;" v-for="(item,i) in InstrumentDetailedData.charges">
							     	
							     	<span style="color: red; " v-if="i==0||i==InstrumentDetailedData.charges.length-1">￥{{item.price.toFixed(2)}}</span><span v-if="i==0">~</span><span v-if="i==InstrumentDetailedData.charges.length-1">元/min </span>
							     </span>
							   
							  </a-popover>
							
							<!-- <p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;"  v-show="i==0||i"><span style="color: red;">￥{{item.price.toFixed(2)}}</span> 元/min</p> -->
							
						</div>
						<div v-show="InstrumentDetailedData.charges.length==1" style="display: flex;" v-for="(item,i) in InstrumentDetailedData.charges">
							<p >上机计费：</p>
						<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;" > <span style="color: red;">￥{{item.price.toFixed(2)}}</span> 元/min</p>
							
						</div>
						<div v-show="InstrumentDetailedData.charges.length==0" style="display: flex;" >
							<p >上机计费：</p>
						
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;" >免费</p>
						</div>
						<div style="display: flex;">
							<p>预约考核：</p>
							<p @click="$router.push({path:'/exam'})" style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;color: #1890FF;font-weight: 400;cursor: pointer;text-decoration: underline;" v-if="InstrumentDetailedData.shouldExamine==true">去考核</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;" v-if="InstrumentDetailedData.shouldExamine==false">-</p>
							
						</div>
						<div style="display: flex;">
							<p>开放预约至：</p>																		
							<p v-if="InstrumentDetailedData.openBookingHours==0" style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{'不限制'}}</p>
							<p v-else-if="InstrumentDetailedData.openBookingHours!=0" style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.openBookingHoursTime}}</p>
						</div>
						<div style="display: flex;">
							<p>最大预约时长：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.maxMinutePerTime}} min</p>
						</div>
						<div style="display: flex;">
							<p>最小预约时长：</p>
							<p style="color: rgba(0, 0, 0, 0.85);font-weight: 500;margin-left: 10px;">{{InstrumentDetailedData.minMinutePerTime}} min</p>
						</div>
						<!-- <div style="display: flex;">
							<p>资料库：</p>
							<a @click="database">查看详情</a>
						</div> -->
						<!-- <div style="display: flex;">
							<div style="width: 120px;">其他规则：</div>
							<div style="display: flex;flex-wrap: wrap;">
								<div style="width: 80px;height: 20px;background: #1890FF;border-radius: 2px;font-size: 12px;color: white;display: flex;justify-content: center;align-items: center;">
									计费系数   {{InstrumentDetailedData.chargeCoefficient.split('.')[0]}}
								</div>
								<div style="margin-left: 10px; width: 96px;height: 20px;background: #1890FF;border-radius: 2px;font-size: 12px;color: white;display: flex;justify-content: center;align-items: center;">
									从账户余额扣费
								</div>
								<div style="margin-top: 10px;  width: 168px;height: 20px;background: #1890FF;border-radius: 2px;font-size: 12px;color: white;display: flex;justify-content: center;align-items: center;">
									在预约开始前取消可退预约费
								</div>
							</div>
							
							
							
						</div> -->
						
					</a-col>
				</a-col>
			</a-row>
		</div>
		<div style="width: 75rem;margin: 0 auto;background-color: white;margin-top: 0.9375rem;">
			<a-tabs style="padding: 0.625rem 0.9375rem;"  class="ins" default-active-key="1" @change="changeTabPane" >
			      <a-tab-pane key="1" tab="预约日历">
			       <div class='demo-app'>
			       	<!-- <div class='demo-app-sidebar'>
			       		<div class='demo-app-sidebar-section'>
			       			<h2>Instructions</h2>
			       			<ul>
			       				<li>Select dates and you will be prompted to create a new event</li>
			       				<li>Drag, drop, and resize events</li>
			       				<li>Click an event to delete it</li>
			       			</ul>
			       		</div>
			       		<div class='demo-app-sidebar-section'>
			       			<label>
			       				<input type='checkbox' :checked='calendarOptions.weekends' @change='handleWeekendsToggle' />
			       				toggle weekends
			       			</label>
			       			<a-button  @click='handleWeekendsToggle'>dddd</a-button>
			       		</div>
			       		<div class='demo-app-sidebar-section'>
			       			<h2>All Events ({{ currentEvents.length }})</h2>
			       			<ul>
			       				<li v-for='event in currentEvents' :key='event.id'>
			       					<b>{{ event.startStr }}</b>
			       					<i>{{ event.title }}</i>
			       					<b>{{ event.endStr }}</b>
			       				</li>
			       			</ul>
			       		</div>
			       	</div> -->
			       	<div  class='demo-app-main' style="position: relative;">
						<div style="position: absolute;left: 400px;">
										
										<div style="display: flex;align-items: center;">
											<div v-for="(item,i) in colorList" style="padding: 0 1rem;">
												<div @click="selectedColor=i"  :key="i" class="colorList"
													:style="'background-color:'+ item.color">
													
													<!-- <img v-if="selectedColor==i" style="transform: scale(0.8);" src="../../assets/images/gou.png"> -->
												</div>
												<div style="font-weight: bold;">
													{{item.text}}
												</div>
											</div>
											
											
										</div>
									</div>

			       		<!-- <a-button  :class="calendarOptions.weekends==false?'a_dark':''" style=" margin: 0 auto;margin-bottom:0.3125rem;  width: 4rem;height: 2.125rem;background-color:#737F8A;display: flex;justify-content: center;align-items: center;color: white;"  @click='handleWeekendsToggle'>
			       			<span v-if="calendarOptions.weekends==false">显示周末</span>
			       			<span v-if="calendarOptions.weekends==true">隐藏周末</span>
			       		</a-button> -->
			       		<FullCalendar ref="calendars"   class='demo-app-calendar' :options='calendarOptions'>
			       			<template v-slot:eventContent='arg'>
			       				
			       				<div v-html="arg.event.title" style="display: flex;justify-content: center;"></div>
			       				
			       			</template>
			       		</FullCalendar>
			       	</div>
			       </div>
			      </a-tab-pane>
			     <a-tab-pane key="2" tab="预约策略">
			     					<div style="min-height: 500px;padding-bottom: 10px;">
									<FullCalendar ref="calendars"   class='demo-app-calendar' :options='calendarOptions2'>
										<template v-slot:eventContent='arg'>
											
											<div v-html="arg.event.title" style="display: flex;justify-content: center;"></div>
											
										</template>
									</FullCalendar>
			     					</div>
			     				</a-tab-pane>
			     				<a-tab-pane key="3" tab="仪器说明">
									<table width="90%" class="table">
	
										<tr>
									
											<td>
									
											<div  style="font-weight: 500;">
												标签
											</div>
											
									
											</td>
									
											<td>
											<div  style="font-weight: 500;">
												{{InstrumentDetailedData.tag}} 
											</div>
				
											</td>
									
											<td>
									
												<div  style="font-weight: 500;">
													型号
												</div>
									
											</td>
									
											<td>
									
												<div style="min-width: 50px;">{{!InstrumentDetailedData.model?'':InstrumentDetailedData.model}}</div>
									
											</td>
									
										</tr>
									
										<tr>
									
											<td>
									
												<div  style="font-weight: 500;">
													资产编号
												</div>
												
									
											</td>
								
											<td>
									
												<div>{{InstrumentDetailedData.assetNo}}</div>
									
											</td>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													产地
												</div>
									
											</td>
									
											<td>
									
												<div>{{InstrumentDetailedData.originPlace}}</div>
									
											</td>
									
										</tr>
									
										<tr>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													采购价
												</div>
									
											</td>
									
											<td>
									
												<div>{{InstrumentDetailedData.purchasePrice.toFixed(2)}}</div>
									
											</td>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													采购日期
												</div>
									
											</td>
									
											<td>
									
												<div>{{InstrumentDetailedData.purchaseDate}}</div>
									
											</td>
									
										</tr>
									
										<tr>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													生产公司
												</div>
									
											</td>
									
											<td>
									
												<div>{{InstrumentDetailedData.company}}</div>
									
											</td>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													性能指标
												</div>
									
											</td>
									
											<td>
									
												<div>{{InstrumentDetailedData.performanceIndex}}</div>
									
											</td>
									
										</tr>
									
										<tr>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													用途
												</div>
									
											</td>
									
											<td>
									
												<div>{{InstrumentDetailedData.purpose}}</div>
									
											</td>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													有效期
												</div>
									
											</td>
									
											<td>
									
												<div>{{InstrumentDetailedData.validityDate}}</div>
									
											</td>
									
										</tr>
									
										<tr>
									
									
											<td>
									
												<div  style="font-weight: 500;">
													操作说明
												</div>
									
											</td>
											<td>
									
												<div>{{InstrumentDetailedData.operation}}</div>
									
											</td>
									
											<!-- <td>
									
												
									
											</td>
									
											<td>
									
												
									
											</td> -->
									
										</tr>
									
									</table>
									<div style="margin-left: 55px;margin-top: 10px;">
										
										<div v-html="InstrumentDetailedData.explain">
											<div  style="font-weight: 500;min-height: 200px;">
												介绍说明：
											</div>
											
										</div>
									</div>
			     					<!-- <div style="width: 100%; min-height: 185px;padding-bottom: 10px;display: flex;">
										<a-row>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														标签：
													</div>
													<p>{{InstrumentDetailedData.tag}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														型号：
													</div>
													<p>{{InstrumentDetailedData.model}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														资产编号：
													</div>
													<p>{{InstrumentDetailedData.assetNo}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														产地：
													</div>
													<p>{{InstrumentDetailedData.originPlace}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														采购价：
													</div>
													<p>{{InstrumentDetailedData.purchasePrice.toFixed(2)}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														采购日期：
													</div>
													<p>{{InstrumentDetailedData.purchaseDate}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														生产公司：
													</div>
													<p>{{InstrumentDetailedData.company}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														性能指标：
													</div>
													<p>{{InstrumentDetailedData.performanceIndex}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														用途：
													</div>
													<p>{{InstrumentDetailedData.purpose}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														有效期：
													</div>
													<p>{{InstrumentDetailedData.validityDate}}</p>
												</div>
												
											</a-col>
											<a-col :span="6">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														操作说明：
													</div>
													<p>{{InstrumentDetailedData.operation}}</p>
												</div>
												
											</a-col>
											
											<a-col :span="18">
												<div style="display: flex;">
													<div  style="font-weight: 500;">
														介绍说明：
													</div>
													<p v-html="InstrumentDetailedData.explain"></p>
												</div>
												
											</a-col>
										</a-row>
										</div> -->
			     				</a-tab-pane>
			     				<!-- <a-tab-pane key="4" tab="仪器报修">
			     					<div style="min-height: 185px;padding-bottom: 10px;">
			     						<a-row>
			     							<a-col :span="10">
			     								<div style="display: flex;">
			     									<div style="width: 90px;font-size: 15px;font-weight: 500;">问题描述：</div>
			     									<a-textarea v-model="fixMsg" style="width: 420px" :rows="4"></a-textarea>
			     								</div>
			     							</a-col>
			     							<a-col :span="10" :offset="4">
			     								<div  style="display: flex;">
			     									<div style="width: 90px;font-size: 15px;font-weight: 500;">图片附件：</div>
			     									<a-upload
													
			     									method="post"
			     									  list-type="text"
			     									  name="input"
			     									  :action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
			     									   :file-list="fileList"
			     									   @change="handleChange"
			     									  
			     									>
			     									  <a-button> <a-icon type="upload" /> 点击上传 </a-button>
			     									</a-upload>
			     								</div>
			     							</a-col>
			     							<a-col :span="24" style="display: flex;justify-content: center;margin-top: 40px;">
			     								<a-button @click="submitFix" type="primary" style="height: 40px;">提交</a-button>
			     							</a-col>
			     						</a-row>
			     					</div>
			     				</a-tab-pane> -->
								<a-tab-pane key="5" tab="送样检测" v-if="InstrumentDetailedData.canSample&&InstrumentDetailedData.state!='故障'">
									<div style="min-height: 185px;padding-bottom: 20px;width: 73rem;">
										<div  style="display: flex;align-items: baseline;margin-left: 30px;margin-bottom: 10px;margin-top: 10px;">
											<p style="margin-right: 0.9375rem;">送样时间</p>
											<a-range-picker  show-time format="YYYY-MM-DD HH:mm" v-model="orderTimes" @change="onChangeDates"/>
										</div>
										<a-row style="margin: 0 auto; color: #FFFFFF !important; padding: 10px;border-bottom: 1px solid #E5F6FE;background-color: #1990FF;border-top-left-radius: 4px;border-top-right-radius: 4px;">
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												检测单模板
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												上传检测单
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												检测单
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												样品名
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												备注
											</a-col>
											<a-col  :span="2" style="text-align: center;" class="orderCol">
												单价
											</a-col>
											<a-col  :span="2" style="text-align: center;" class="orderCol">
												样品状态
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												数量
											</a-col>
											<a-col  :span="1" style="text-align: center;" class="orderCol">
												总价
											</a-col>
											
										</a-row>
										<a-row  class="antique rowHover" v-for="(item,index) in SelSamplesData" style="padding: 10px;border-bottom: 1px solid #DDDDDD;">
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												<a :href="item.filePath" target="_blank">{{item.fileName}}</a>
																						</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												<a-upload
												class="yqyq"
												method="post"
												  list-type="text"
												  name="input"
												  :action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
												   
												   @change="handleChangeds($event,index)"
												>
												  <a-button> <a-icon type="upload" /> 点击上传 </a-button>
												 
												</a-upload>
												 
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												<p style="overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;">{{orderValueBox[index].orderTestCordName}}</p>
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												{{item.sampleName}}
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												<a-popover>
												    <template slot="content">
												     <div style="width: 300px;">
														{{item.remarks}}
													 </div>
												    </template>
												    <span style="color: #1990FF;cursor: pointer;">
												      查看
												    </span>
												  </a-popover>
											</a-col>
											<a-col  :span="2" style="text-align: center;" class="orderCol">
												{{item.price.toFixed(2)}}元/{{item.unit}}
											</a-col>
											<a-col  :span="2" style="text-align: center;" class="orderCol">
												<a-select default-value="0" style="width: 80px" v-model="orderValueBox[index].orderStatus">
													
													<a-select-option :value="0">
														固态
													</a-select-option>
													
													<a-select-option :value="1">
														液体
													</a-select-option>
													<a-select-option :value="2">
														气态
													</a-select-option>
													<a-select-option :value="3">
														粉末
													</a-select-option>
													<a-select-option :value="4">
														其他
													</a-select-option>
												</a-select>
											</a-col>
											<a-col  :span="3" style="text-align: center;" class="orderCol">
												<a-input-number style="width: 80px" defaultValue="0"  id="inputNumber" v-model="orderValueBox[index].orderValue" :min="0"  @change="onChange" />
											</a-col>
											<a-col  :span="1" style="text-align: center;" class="orderCol">
												{{orderValueBox[index].orderAllValue*orderValueBox[index].orderValue}}
											</a-col>
											
										</a-row>
									</div>
									<a-textarea placeholder="请输入备注信息" :rows="4" v-model="orderRemarks" style="width: 100%" />
									<div style=" display: flex;flex-direction: column;align-items: flex-end;margin-top: 30px;">
										<div style="display: flex;align-items: baseline;">
											<p style="margin-right: 15px;">
												总计 <span style="color: #3FA6FB;">{{allNumber}}</span> 件，<span style="color: #3FA6FB;">{{allPrice}}</span> 元
											</p>
											
											<a-button type="primary" style="margin-right: 15px;" @click="goShoping">立即下单</a-button>
			
											
											<!-- <a-button type="primary" style="margin-right: 15px;" @click="goShoping">立即下单</a-button> -->
										</div>
									</div>
								</a-tab-pane>
								<a-tab-pane key="6" tab="操作视频" v-if="InstrumentDetailedData.videoPath!=null">
									<div style="margin-top: 1.25rem;z-index: -1;">
										<video style="max-height:650px;width: 100%;" controls :src="InstrumentDetailedData.videoPath"  loop="loop" muted="muted"></video>
									</div>
								</a-tab-pane>
								
			    </a-tabs>
				
		</div><a-modal width="350px" title="确认下单信息" :visible="visible2" @ok="handleOk" @cancel="handleCancel">
			<a-row style="max-height: 320px;overflow-y: scroll;width: 100%;">
				<a-col :span="24" v-for="(item,index) in orderShopBox">
					<div style="display: flex;">
						<p>{{index+1}}. {{item.goodsName}}*{{item.orderValue}} </p>
						<p style="margin-left: 5px;">{{(item.orderValue*item.orderAllValue).toFixed(2)}}元</p>
					</div>
				</a-col>
			</a-row>
			<div style="width: 90%;border-top: 1.6px solid #EEEEEE;">
				<p style="margin-top: 15px;margin-bottom: -8px;">订单总费用 <span style="margin-left: 5px;">{{allPrice.toFixed(2)}} 元</span></p>
			</div>
		</a-modal>
		
		
		<a-modal  class="flflf" width='360px' v-model="visible" title="预约信息确认" ok-text="确认" cancel-text="取消" @ok="okModal">
			<div style="display: flex;flex-direction: column;height: 415px;">
				<div style="display: flex;align-items: center ;flex-direction: column;">
					<div style="width: 100%;height: 10px;background-color:#F0C30F;position: absolute;top: 0;border-top-left-radius:2px;border-top-right-radius: 2px;">
						
					</div>
					<img style="margin: 20px 0;" src="../../assets/images/问号.png">
					<div  style="font-size: 25px;font-weight: 600;color: #212121;margin-bottom: 20px;">确认预约信息</div>
					<div style="color: #E05562;font-size: 15px;font-weight: 500;margin-bottom: 10px;">{{yMessage.time}}</div>
					<div style="font-size: 15px;margin-bottom: 10px;">时长：<span style="font-weight: 500;color: #E05562;">{{yMessage.minutes}}</span>分钟 / 预约费：<span style="font-weight: 500;color: #E05562">{{yMessage.cost!='免费'?yMessage.runCost+'元':'免费'}}</span></div>
					<div style="font-size: 15px;margin-bottom: 10px;">预计上机费：<span style="font-weight: 500;color: #E05562">{{yMessage.runCost!='免费'?yMessage.runCost+'元':'免费'}}</span></div>
					<div style="display: flex;">
						<span style="color: #E05562;margin-right: 5px;margin-top: 4px;" v-if="InstrumentDetailedData.mustFillInRemarks">*</span>
						<a-input v-model="modalTitle"  placeholder="请填写备注信息" style="width: 250px;height: 35px;"></a-input>
					</div>
					
					<div style="display: flex;align-self: flex-start;margin-left: 35px;font-size: 15px;margin-top: 10px;" v-show="InstrumentDetailedData.bookRemarks">
						<div>提示：</div>
						 <a-tooltip>
						    <template slot="title">
						     {{InstrumentDetailedData.bookRemarks}}
						    </template>
						   <div style="color: #E05562;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width: 200px;">{{InstrumentDetailedData.bookRemarks}}</div>
						  </a-tooltip>
					</div>
					<a-checkbox-group v-if="InstrumentDetailedData.reservationRemarks" v-model="remarkSelect"  @change="onChange" style="max-height: 48px;overflow-y: scroll;width: 240px;margin-top: 8px;">
					    <a-row>
					      <a-col :span="12" v-for="(item,index) in InstrumentDetailedData.reservationRemarks.split(',')">
					        <a-checkbox :value="item">
					          {{item}}
					        </a-checkbox>
					      </a-col>
					      </a-col>
					    </a-row>
					  </a-checkbox-group>
					<div style="display: flex;position: absolute;bottom: 10px;">
						<a-button style="margin: 0 5px;width: 80px;height: 38px;" type="primary" @click="okModal">确认</a-button>
						<a-button style="margin: 0 5px;width: 80px;height: 38px;" @click="visible=false">取消</a-button>
					</div>
					 
					</div>
				<!-- placeholder="InstrumentDetailedData.bookRemarks -->
				<!-- <div><span style="font-weight: bold;margin-right: 5px;">预约费用: </span> {{yMessage.cost!='免费'?yMessage.runCost+'元':'免费'}}<span style="font-weight: bold;margin-right: 5px;padding-left: 30px;">预约时长: </span> {{yMessage.minutes}}分钟</div>
				<div></div>
				<div><span style="font-weight: bold;margin-right: 5px;">预约上机费用: </span> {{yMessage.runCost!='免费'?yMessage.runCost+'元':'免费'}}</div>
				<div style="display: flex;"><span style="font-weight: bold;margin-right: 5px;">预约时间: </span> {{yMessage.time}}</div>
				<div style=""><span style="font-weight: bold;" ></span><a-textarea  v-model="modalTitle"  :placeholder="InstrumentDetailedData.bookRemarks" style="margin-top: 5px;"  :rows="4" /></div> -->
				
			</div>
			<div>
				<!-- <p style="color: #525f7f;
    font-size: .875rem;
    font-weight: 600;
}">备注信息</p> -->
				
			</div>

			
		</a-modal>
	</div>
</template>

<script>
	
	import strategy from '@/components/strategy.vue'
	import moment from 'moment'
	import { Modal } from 'ant-design-vue';
	import {SelInstrumentDetailed,ReservationInstrument,SelInstrumentPrice,EquipmentRepair,SelSamples,placeOrderSamples,SelInstrumentStrategy} from '@/api/index.js'
	import FullCalendar from '@fullcalendar/vue'
	import dayGridPlugin from '@fullcalendar/daygrid'
	import timeGridPlugin from '@fullcalendar/timegrid'
	import interactionPlugin from '@fullcalendar/interaction'
	import {
		INITIAL_EVENTS,
		createEventId
	} from '../../event-utils.js'

	export default {
		name:'/instrumentDetail',
		components: {
			FullCalendar, // make the <FullCalendar> tag available
			strategy
		},

		data: function() {
			return {
				remarkSelect:[],
				runModel:'',
				totalTimeOvO:false,
				totalTime: 3,    //记录具体倒计时时间
				totalTimeBtn:false,
				content:'',
				strategyData:[],
				strategyPt:[],
				strategyJjr:[],
				allNumber:0,
				orderTimes:'',
				allPrice:0,
				visible2:false,
				orderShopBox:[],
				fixMsg:'',
				orderRemarks:'',
				orderValueBox:[],
				fileListds:[],
				SelSamplesData:[],
				fileListDemo:[],
				weekIndex:0,
				fileList:[],
				ifAdd:true,
				openBookingHoursTime: '',
				ids:this.$route.query.ids?this.$route.query.ids:'',
				InstrumentDetailedData:[],
				selectInfo: '',
				calendarApi: '',
				modalTitle: '',
				selectedColor: 0,
				visible: false,
				yMessage:[],
				calendarOptions: {
					events:[],
					slotDuration:'00:15:00',
					buttonText: {
						today: '今天',
						month: '月视图',
						week: "周",
						day: '日视图',
						
					},
					allDayText: "全天",
					nowIndicator:true,
					allDaySlot: false,
					locale: 'zh-cn',
					plugins: [
						dayGridPlugin,
						timeGridPlugin,
						interactionPlugin // needed for dateClick
					],
					// headerToolbar: {
					// 	left: 'prev,next today',
					// 	center: 'title',
					// 	right: 'dayGridMonth,timeGridWeek,timeGridDay'
					// },
					initialView: 'timeGridWeek',
					initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
					editable: true,
					selectable: true,
					selectMirror: true,
					dayMaxEvents: true,
					eventLimit: 6,
					
					scrollTime: new Date().toLocaleTimeString(),
					 editable: true,
					    
					firstDay: 1,
					weekends: true,
					select: this.handleDateSelect,
					eventClick: this.handleEventClick,
					eventsSet: this.handleEvents,
					// refetchEvents:false,
					/* you can update a remote database when these fire:
					eventAdd:
					eventChange:
					eventRemove:
					*/
				},
				calendarOptions2: {
					 events: [
						 // {
						 //               daysOfWeek: ["0"],
						 //               startTime: "11:00:00",
						 //               endTime: "11:30:00",
						 //               color: "red",
						 //               title: "每周一重复(拖动试试)",
						 //             },
					
					 ], 
				
					slotDuration:'00:30:00',
					buttonText: {
						today: '今天',
						month: '月视图',
						week: "周",
						day: '日视图',
						
					},
					allDayText: "全天",
					nowIndicator:true,
					allDaySlot: false,
					locale: 'zh-cn',
					plugins: [
						dayGridPlugin,
						timeGridPlugin,
						interactionPlugin // needed for dateClick
					],
					// headerToolbar: {
					// 	left: 'prev,next today',
					// 	center: 'title',
					// 	right: 'dayGridMonth,timeGridWeek,timeGridDay'
					// },
					initialView: 'timeGridWeek',
					
					initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
					editable: false,
					selectable: false,
					selectMirror: false,
					dayMaxEvents: true,
					eventLimit: 6,
					
					scrollTime: new Date().toLocaleTimeString(),
					 editable: false,
					
					firstDay:1,
					weekends: true,
					// select: this.handleDateSelect,
					// eventClick: this.handleEventClick,
					// eventsSet: this.handleEvents,
					// refetchEvents:false,
					/* you can update a remote database when these fire:
					eventAdd:
					eventChange:
					eventRemove:
					*/
				},
				currentEvents: [],
				 colorList: [
				// 		color: '#11CDEF',
				// 	},
				// 	{
				// 		color: '#FB6340',
				// 	},
					{
						color: 'rgba(187, 187, 187,0.8)',
						text:'已过期'
					},
					// {
					// 	color: '#2DCE89',
					// },
					{
						color: '#172B4D',
						text:'不可预约'
					},
					// {
					// 	color: '#5E72E4',
					// },
					{
						color: 'rgba(0, 0, 255,0.8)',
						text:'已预约'
					},
					{
						color: 'rgba(255, 165, 0,0.8)',
						text:'审核中'
					},
					{
						color: 'rgba(255, 0, 0,0.6)',
						text:'故障中'
					},
					{
						color: 'rgba(143, 53, 212,0.6)',
						text:'不开放'
					}
				]
			}
		},
		mounted(){
			
		},
		created(){
			
			this.runModel = process.env.NODE_ENV
			this.ids = this.$route.query.ids?this.$route.query.ids:''
			
			this.getSelInstrumentDetailed({
				InstrumentId:this.ids,
				weekIndex:this.weekIndex
			},'first')
			
			this.getSelInstrumentDetailed2({
				instrumentId:this.ids
			})
			this.getSelSamples({InstrumentId:this.ids})
			
			
			
			
		},
		methods: {
		 async	getSelInstrumentDetailed2(data){
				const res = await SelInstrumentStrategy(data)
				this.strategyData = res.data.data
				// this.strategyPt = 
				res.data.data.pt.map((n)=>{
					this.strategyPt.push({daysOfWeek:[n.day],startTime:n.beginTime,endTime:n.endTime=='00:00:00'?'24:00:00':n.endTime,color:n.strategyType==0?"rgba(134, 180, 234,0.8)":n.strategyType==1?"rgba(255, 106, 51,0.8)":n.strategyType==2?"rgba(81, 81, 81,0.8)":n.strategyType==3?"rgba(148, 119, 109,0.8)":n.strategyType==4?"rgba(255, 51, 51,0.8)":"",title:n.description})
				})
				// res.data.data.jjr.map((n)=>{
					
				// 	this.strategyJjr.push({startTime:n.holidayDate.slice(0,10).replace('/','-').replace('/','-')+"T"+n.beginTime,endTime:n.holidayDate.slice(0,10).replace('/','-').replace('/','-')+"T"+n.endTime=='00:00:00'?n.holidayDate.slice(0,10).replace('/','-').replace('/','-')+"T"+'24:00:00':n.holidayDate.slice(0,10).replace('/','-').replace('/','-')+"T"+n.endTime,color:'' ,title:n.description})
				// })
				this.calendarOptions2.events = this.strategyPt
				console.log(this.strategyPt)
				
				// this.strategyJjr.map((n)=>{
				// 	this.calendarOptions2.events.push(n)
				// })
				console.log(this.calendarOptions2.events)
			},
			changeTabPane(val){
				console.log(val)
				if(val==4||val==5){
					let isLogin = window.localStorage.getItem('Authorization')
					var that = this
					if(!isLogin){
						let secondsToGo = 3;
						     const modal = this.$success({
						       title: '暂无权限操作，请前往登录再操作',
							    okText: '立即前往登录',
						       content: `${secondsToGo}秒后自动跳转前往登录`,
							   onOk() {
							   	that.$router.push({name:'login'})
							   },
						     });
						     const interval = setInterval(() => {
						       secondsToGo -= 1;
						       modal.update({
						         content: `${secondsToGo}秒后自动跳转前往登录`,
						       });
						     }, 1000);
						     setTimeout(() => {
						       clearInterval(interval);
							   that.$router.push({name:'login'})
						       modal.destroy();
						     }, secondsToGo * 1000);
							 return
					}
				}
			},
			database(){
				this.$router.push({path:'/database',query:{InstrumentId:this.InstrumentDetailedData.instrumentId,InstrumentName:this.InstrumentDetailedData.instrumentName}})
			},
			totalEvent(data){
				console.log(data)
				// window.sessionStorage.setItem('仪器'+data.labId+data.instrumentId,true)
				this.totalTimeOvO = false
			},
			countDown () {
				this.totalTimeOvO = true
			this.totalTimeBtn = false
			this.content = '确认已读须知 '+this.totalTime+'s '  //这里解决60秒不见了的问题
			var that = this
			let clock = window.setInterval(() => {
			
			  that.totalTime--
			
			  that.content =  '确认已读须知 '+this.totalTime+'s ' 
			
			  if (that.totalTime < 0) {    //当倒计时小于0时清除定时器
			
			    window.clearInterval(clock)
			
			    that.content = '确认已读须知 '
				that.totalTimeBtn = true
			 
			
			    }
			
			},1000)
			
		},
			async handleOk(){
				
					// let orderShopBox = []
					//  this.orderValueBox.map((n)=>{
					// 	if(n.orderValue>0){
					// 		orderShopBox.push(n)
					// 	}
					// })
					// this.orderShopBox = orderShopBox
					// if(this.orderShopBox==0){
					// 	this.$message.error("订单数量为空，请检查后重试")
					// 	return 
					// }
					let ItemIds = []
					let Numbers = []
					let SampleStates = []
					let FilePaths = []
					this.orderShopBox.map((n)=>{
					ItemIds.push(n.goodsId)
					Numbers.push(n.orderValue)
					SampleStates.push(n.orderStatus)
					FilePaths.push(n.orderTestCord)
					})
					console.log(moment(this.orderTimes[0]).format('YYYY-MM-DD HH:mm:ss'))
					
					const res = await placeOrderSamples({InstrumentId: this.InstrumentDetailedData.instrumentId,ItemIds:ItemIds,Numbers:Numbers,SampleStates:SampleStates,FilePaths:FilePaths,Remarks:this.orderRemarks,SamplingBeginTime:moment(this.orderTimes[0]).format('YYYY-MM-DD HH:mm:ss'),SamplingEndTime:moment(this.orderTimes[1]).format('YYYY-MM-DD HH:mm:ss')})
					// this.visible = false;
					if(res.data.state){
						this.visible = false;
						this.$message.success("已成功生成订单")
						this.$router.push({path:'/core/deliveryTest'})
					}
					else{
						this.$message.error(res.data.info)
					}
					
			},
			goShoping(){
				
				let orderShopBox = []
				 this.orderValueBox.map((n)=>{
					if(n.orderValue>0){
						orderShopBox.push(n)
					}
				})
				this.orderShopBox = orderShopBox
				if(this.orderShopBox==0){
					this.$message.error("订单数量为空")
					return 
				}
				 if(this.orderTimes==''){
					this.$message.error("请选择送样时间")
					return 
				}
				let isSock = false
				let isSock2 = false
				this.orderShopBox.map((n,i)=>{
					console.log(n)
					if(n.mustUploadFile==true&&n.orderTestCordName==""){
						this.$message.error("样品("+n.goodsName+")必须上传检测单")
							isSock = true
					}
				})
				// else{
					
					
				// }
				if(isSock==true){
					return
				}
				// this.orderShopBox.map((n,i)=>{
					
				// 	if(n.mustUploadFile==false&&n.orderTestCordName==""){
				// 		isSock2 = true
						
				// 		// this.$message.error("样品("+n.goodsName+")检测单为空")
						
				// 		return
				// 	}
				// })
				// if(isSock2==true){
				// 	var that = this
				// 	Modal.confirm({
				// 	       title: "样品检测单为空,请确认是否下单",
				// 	       onOk() {
				// 	         that.visible2 = true;
				// 	       },
				// 	       // eslint-disable-next-line @typescript-eslint/no-empty-function
				// 	       onCancel() {},
				// 	     });
				// 	return
				// }
				this.visible2 = true;
				console.log(this.orderShopBox)
				
			},
			handleCancel(e) {
				this.visible2 = false;
			},
			handleChangeds(val,index){
				// console.log(val)
				// if(this.fileList.length>1){
				// 	return
				// }
				
				if(!val.file.response){
					return
				}
				console.log(val)
				// this.orderValueBox[index].orderTestCord = "7"
				// console.log(val.file.response.data.data[0].name)
				this.orderValueBox[index].orderTestCordName = val.file.response.data.data[0].name
				this.orderValueBox[index].orderTestCord = val.file.response.data.data[0].path
				this.$message.success("文件上传成功")
				// if(val.file.response){
				// 	console.log(val.file.response.data.data[0].name)
				// 	console.log(val.file.response.data.data[0].path)
				// 	this.orderValueBox[index].orderTestCord = "666"
				// 	// this.orderValueBox[index].orderTestCord = val.file.response.data.data[0].path
				// }
				// this.fileListds[`${index}`] = val.file
				// this.fileListDemo[index] = val.file
			},
			async getSelSamples(data){
				const res = await SelSamples(data)
				this.SelSamplesData = res.data.data
				this.SelSamplesData.map((n,index)=>{
					this.fileListDemo[index] = {name:'',path:''}
				})
				this.SelSamplesData.map((n,i,item)=>{
					this.orderValueBox.push({
						orderValue:0,
						orderAllValue:n.price,
						orderStatus:0,
						orderTestCordName:'',
						orderTestCord:'',
						goodsName:n.sampleName,
						goodsId:n.instrumentSampleId,
						mustUploadFile:n.mustUploadFile
					})
				})
				console.log(res)
			},
			async okModal() {
				console.log(this.remarkSelect)
				if(this.remarkSelect.length>0){
					this.modalTitle = this.modalTitle+' 勾选备注：'+this.remarkSelect.join(',')
				}
				console.log(this.modalTitle)
				
				console.log(this.modalTitle)
				console.log(this.colorList[this.selectedColor].color)
				if(this.InstrumentDetailedData.mustFillInRemarks&&this.modalTitle==''){
					this.$message.error("请填写备注后再提交")
					return
				}
					this.visible = false
				if (true) {
					//this.modalTitle
					
					const res = await ReservationInstrument({
						instrumentId: this.selectInfo.id,
						remarks: this.modalTitle,
						// beginTime: this.selectInfo.startStr,
						// endTime:this.selectInfo.endStr
						beginTime: this.selectInfo.startStr.split('+')[0],
						endTime:this.selectInfo.endStr.split('+')[0]
					}) 
					// document.getElementById('calendar').fullCalendar( 'removeEventSource',this.events);
					
					// $('#calendar').fullCalendar( 'refetchEvents');
					// $('#calendar').fullCalendar( 'addEventSource', arr);
					if(res.data.state){
						
						this.getSelInstrumentDetailed({
							InstrumentId:this.ids,
							weekIndex:this.weekIndex
						})
						
						this.modalTitle = ''
						this.selectedColor = 0
						// if(this.InstrumentDetailedData.instrumentType=='门禁'){
						// 	this.$router.push({path:'/core/accessControlCore'})
						// }
						// else if(this.InstrumentDetailedData.instrumentType=='仪器'){
						// 	this.$router.push({path:'/core/instrumentCore'})
						// }
						this.$notification.open({
						       message: '提示信息',
						       description:
						         '预约成功',
						       icon: <a-icon type="smile" style="color: #108ee9" />,
						     }); 
							 
					}
					else{
						this.$message.error(res.data.info)
					}
					console.log(res)
					// this.calendarApi.addEvent({
					// 	id: this.selectInfo.id,
					// 	title: this.modalTitle,
					// 	start: this.selectInfo.startStr,
					// 	end: this.selectInfo.endStr,
					// 	allDay: this.selectInfo.allDay,
					// 	allDaySlot:true,
					// 	color: this.colorList[this.selectedColor].color
					// })
					
				}
				else{
					this.$notification.open({
					       message: '提示信息',
					       description:
					         '事件名为空，事件未创建',
					       icon: <a-icon type="meh" style="color: #108ee9" />,
					     });
				}
		
				

			},
			handleWeekendsToggle() {
				this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
			},
			async handleDateSelect(selectInfo) {
				let isLogin = window.localStorage.getItem('Authorization')
				var that = this
				if(!isLogin){
					let secondsToGo = 3;
					     const modal = this.$success({
					       title: '暂无权限操作，请前往登录再操作',
						    okText: '立即前往登录',
					       content: `${secondsToGo}秒后自动跳转前往登录`,
						   onOk() {
						   	that.$router.push({name:'login'})
						   },
					     });
					     const interval = setInterval(() => {
					       secondsToGo -= 1;
					       modal.update({
					         content: `${secondsToGo}秒后自动跳转前往登录`,
					       });
					     }, 1000);
					     setTimeout(() => {
					       clearInterval(interval);
						   that.$router.push({name:'login'})
					       modal.destroy();
					     }, secondsToGo * 1000);
						 return
				}
				console.log(this.InstrumentDetailedData)
				let id = this.InstrumentDetailedData.instrumentId
				this.selectInfo = selectInfo
				this.selectInfo.id = id
				const res = await SelInstrumentPrice({
					instrumentId: this.selectInfo.id,
					beginTime: this.selectInfo.startStr.split('+')[0],
					endTime:this.selectInfo.endStr.split('+')[0]
				})
				if(res.data.state){
					this.visible = true
					this.yMessage = res.data.data
				}
				else{
					this.$message.warning(res.data.info);
					this.visible = false
				}
				
				console.log(selectInfo)

				// let title = prompt('Please enter a new title for your event')
				let calendarApi = selectInfo.view.calendar
				this.calendarApi = calendarApi
				calendarApi.unselect() // clear date selection

			},

			handleEventClick(clickInfo) {
				console.log(clickInfo)
				this.$confirm({
					title: `请确认是否删除'${clickInfo.event.title}'事项?`,
					okText: '确认',
					okType: 'danger',
					cancelText: '取消',
					onOk() {

						clickInfo.event.remove()
						console.log('OK');
					},
					onCancel() {
						console.log('Cancel');
					},
				});


			},
			handleChange(val){
				console.log(val)
				// if(this.fileList.length>1){
				// 	return
				// }
				this.fileList = [val.file]
			},
			onChange(val,item){
				let allNumber = 0
				let allPrice = 0
				this.orderValueBox.map((n)=>{
					allNumber+=n.orderValue
					allPrice+=n.orderAllValue*n.orderValue
				})
				console.log(this.orderValueBox)
				this.allNumber = allNumber
				this.allPrice = allPrice
				
			},
			handleEvents() {
				 console.log(document.querySelector(".fc-prev-button")) 
				 let prev = document.querySelector(".fc-prev-button")
				  let next = document.querySelector(".fc-next-button")
				  let today = document.querySelector(".fc-today-button")
				 
				  var that = this
				 prev.onclick = function(){
					console.log("上一页")
					that.weekIndex-=1
					that.getSelInstrumentDetailed({
						InstrumentId:that.ids,
						weekIndex:that.weekIndex
					})
					
				}
				next.onclick = function(){
					console.log("下一页")
					that.weekIndex+=1
					that.getSelInstrumentDetailed({
						InstrumentId:that.ids,
						weekIndex:that.weekIndex
					})
					
				}
				today.onclick = function(){
					console.log("本周")
					that.weekIndex=0
					that.getSelInstrumentDetailed({
						InstrumentId:that.ids,
						weekIndex:that.weekIndex
					})
				}
				
				 // dd.click(function(){
					//  console.log("点击了")
				 // })
				
			
			
			},
			async getSelInstrumentDetailed(data,statess){
				const res = await SelInstrumentDetailed(data)
				
				this.InstrumentDetailedData = res.data.data
				//&&!window.sessionStorage.getItem('仪器'+this.InstrumentDetailedData.labId+this.InstrumentDetailedData.instrumentId)
				if(this.InstrumentDetailedData.needReadUseIntro==true&&statess=='first'){
					
					this.totalTime=this.InstrumentDetailedData.readUseIntroSecond
					this.countDown()
					
					
				}
				this.calendarOptions.slotDuration = this.InstrumentDetailedData.stepMinute>=10?"00:"+this.InstrumentDetailedData.stepMinute:"00:0"+this.InstrumentDetailedData.stepMinute
				let shuzu = res.data.data.appointmentByWeek.weekStr
				let ddat = res.data.data.appointmentByWeek.appointmentsItem
				
				// let nowYear = res.data.data.appointmentByWeek.startDate.split('-')[0]
				
				
					
					
				// })
				
				// this.calendarOptions.initialEvents=[]
				// this.calendarOptions.events = ggg
				console.log(ddat)
				console.log("算法未处理的数据上面")
				var d1=[];
				for (var i=0;i<ddat.length;i++){
				    if(d1.length>0)
				    {
				        var maxd1=d1[d1.length-1];
				        if(maxd1.userId==ddat[i].userId && maxd1.state==ddat[i].state && maxd1.state==ddat[i].state)
				        {
							d1[d1.length-1].endTime=ddat[i].endTime;
							 d1[d1.length-1].end=ddat[i].end;
						// 	d1[d1.length-1].startTime=ddat[i].startTime;
				  //        d1[d1.length-1].end=ddat[i].end;
						//  d1[d1.length-1].className=ddat[i].state==0?'CanAppointment':ddat[i].state==1?'Reserved':ddat[i].state==2?'NotAppointment':ddat[i].state==3?'Overdue':ddat[i].state==4?'Examine':'';
						//  d1[d1.length-1].userId=ddat[i].id;
						//  d1[d1.length-1].state=ddat[i].state;
						//  d1[d1.length-1].title=ddat[i].title;
						//  d1[d1.length-1].userId=ddat[i].userId;
						// d1[d1.length-1].start=ddat[i].startTime.replace(' ','T').replace('/','-').replace('/','-');
						// d1[d1.length-1].end=ddat[i].endTime.replace(' ','T').replace('/','-').replace('/','-');
				        }
				        else{
				            d1.push(ddat[i]);
				        }
				    }
				    else{d1.push(ddat[i])}
				}
				let gggs1 = []
				d1.map((n)=>{
					console.log(n)
					gggs1.push({
							id: n.rankIndex,
							title: n.state==1||n.state==4?n.title:n.title,
							start: n.startTime.replace(' ','T').replace('/','-').replace('/','-'),
							end:n.endTime.replace(' ','T').replace('/','-').replace('/','-'),
							className:n.state==0?'CanAppointment':n.state==1?'Reserved':n.state==2?'NotAppointment':n.state==3?'Overdue':n.state==4?'Examine':'',
							state:n.state,
							userId:n.userId
					})
				})
				
				this.calendarOptions.events = gggs1
				// {daysOfWeek:[n.day],startTime:n.beginTime,endTime:n.endTime=='00:00:00'?'24:00:00':n.endTime,color:n.strategyType==0?"rgba(134, 180, 234,0.8)":n.strategyType==1?"rgba(255, 106, 51,0.8)":n.strategyType==2?"rgba(81, 81, 81,0.8)":n.strategyType==3?"rgba(148, 119, 109,0.8)":n.strategyType==4?"rgba(255, 51, 51,0.8)":"",title:n.description})
				//
				if(this.InstrumentDetailedData.state=='故障'){
					this.calendarOptions.events = [{daysOfWeek:[1,2,3,4,5,6,0],startTime:'00:00:00',endTime:'24:00:00',className:'fault',title:'故障'}]
				}
				const resp = await SelInstrumentStrategy({
				instrumentId:this.ids
			})
				if(resp.data.data.jjr.length>0){
					resp.data.data.jjr.map((n)=>{
						
						this.calendarOptions.events.push(
						{
								title: '不开放',
								start:n.holidayDate.slice(0,10).replace('/','-').replace('/','-')+"T"+n.beginTime,
								end:n.holidayDate.slice(0,10).replace('/','-').replace('/','-')+"T23:59:59",
								className:'NotAppointment2',
								state:2
						}
						)
					})
				}
				
			// if(resp.data.data.pt.length>0){
			// 	resp.data.data.pt.map((n,i)=>{
			// 		if(n.description=='不开放'){
					
						
			// 				this.calendarOptions.events.push({daysOfWeek:[n.day],startTime:n.beginTime,endTime:n.endTime,className:'NotAppointment',title:'不开放预约'})
			// 		}
					
			// 	})
			// }
				
				
				console.log(this.calendarOptions.events)
				console.log("算法处理完后的数据上面")
				let tempArr = this.calendarOptions.events
				// let target = []
				// for (let i = 0; i < tempArr.length; i++) {
				//         for (let j = i + 1; j < tempArr.length; j++) {
				//             if (tempArr[i].start.split('T')[0] == tempArr[j].start.split('T')[0]) {
				//                 if(tempArr[i].title=='不可预约'){
				// 					target.push(i)
				// 				}
				// 				else if(tempArr[i].title=='超出最大预约范围'){
				// 					target.push(i)
				// 				}
				//             };
				//         };
				//     };
					// target.map((n)=>{
					// 	this.calendarOptions.events.splice(n,1)
					// })
					
					
				this.openBookingHoursTime = moment(res.data.data.openBookingHoursTime).format('YYYY-MM-DD hh:mm:ss');
				setTimeout(()=>{
					var NotAppointment2 = document.getElementsByClassName('NotAppointment2');
					console.log(NotAppointment2.length)
					
					for(let k = 0;k<NotAppointment2.length;k++){
						NotAppointment2[k].parentNode.style = 'inset: 0px 0% -2111px; z-index: 10;'
					}
					
				},10)
				// setTimeout(()=>{
				// 	var NotAppointment = document.getElementsByClassName('NotAppointment');
					
					
				// 	for(let k = 0;k<NotAppointment.length;k++){
				// 		console.log(NotAppointment[k].parentNode.style.inset)
				// 		debugger
				// 		// NotAppointment2[k].parentNode.style = 'inset-bottom: 0 !import; z-index: 10;'
				// 	}
					
				// },10)
			
				
			},
			downFile(e){
				console.log(e)
				// window.open(e)
				
				window.open(e,'_blank')
			},
			ceshi(){
				console.log(this.$refs.calendars)
				console.log(this.$refs.calendars)
			},
			async submitFix(){
				const res = await EquipmentRepair({Content:this.fixMsg,PicturePath:this.fileList.length>0?this.fileList[0].response.data.data[0].path:'',InstrumentId:this.InstrumentDetailedData.instrumentId,FileName:this.fileList.length>0?this.fileList[0].response.data.data[0].name:''})
						if(res.data.state){
							this.$message.success('提交成功')
						}
						else{
							this.$message.error(res.data.info)
						}
			}
		}
	}
</script>

<style lang='css' scoped>
	h2 {
		margin: 0;
		font-size: 16px;
	}

	ul {
		margin: 0;
		padding: 0 0 0 1.5em;
	}

	li {
		margin: 1.5em 0;
		padding: 0;
	}

	b {
		/* used for event dates/times */
		margin-right: 3px;
	}

	.demo-app {
		display: flex;
		min-height: 100%;
		font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
		font-size: 14px;
	}

	.demo-app-sidebar {
		width: 300px;
		line-height: 1.5;
		background: #eaf9ff;
		border-right: 1px solid #d3e2e8;
	}

	.demo-app-sidebar-section {
		padding: 2em;
	}

	.demo-app-main {
		flex-grow: 1;
		padding: 3em;
	}

	.fc {
		/* the calendar root */
		max-width: 1100px;
		margin: 0 auto;
	}

	.colorList {
		
		margin-left: 8px;
		margin-bottom: 5px;
		width: 1.875rem;
		height: 1.875rem;
		border-radius: 100%;
		background-color: #11cdef;
		/* cursor: pointer; */
		
	}
	.a_dark{
		background-color: #1A252F !important;
	}
</style>
<style lang="less">
	// .yqyq .ant-upload-list-item-name{
	// 	display: none !important;
	// }
	.flflf .ant-modal-header{
		display: none !important;
	}
	.flflf .ant-modal-close{
		display: none !important;
	}
	.flflf .ant-modal-footer{
	display: none !important;
	
	}
	.yqyq .ant-upload-list{
		display: none;
	}
	.ins .ant-tabs-tab-active{
		background-color: #3395FF !important;
		color: white !important;
	}
	.blue{
		 pointer-events: none !important; 
		    cursor: default !important; 
		
	}
	 b{
		display: none !important;
	}
	.CanAppointment{
		background-color: transparent !important;
		pointer-events: none !important;
		   cursor: default !important; 
	}
	.fault{
		background-color: rgba(255, 0, 0,0.6) !important;
		pointer-events: none !important;
		   cursor: default !important; 
	}
	.NotAppointment{
		background-color: #172B4D !important;
		pointer-events: none !important;
		   cursor: default !important; 
				
	}
	.NotAppointment2{
		background-color: #8F35D4 !important;
		pointer-events: none !important;
		   cursor: default !important; 
		   
		   
	}
	.Reserved{
		background-color: rgba(0, 0, 255,0.8) !important;
		pointer-events: none !important;
		   cursor: default !important; 
	}
	.Overdue{
		background-color: rgba(187, 187, 187,0.8) !important;
		pointer-events: none !important;
		   cursor: default !important; 
	}
	.Examine{
		background-color: rgba(255, 165, 0,0.8) !important;
		pointer-events: none !important;
		   cursor: default !important; 
	}
	.ins .ant-tabs-tab-active {
		// border-top-right-radius: 5px;
		// border-top-left-radius: 5px;
		background-color: transparent !important;
		color: #1890FF !important;
	}
	 .ins .ant-tabs-ink-bar{
		// display: none !important;
		// background-color: #F0A223 !important;
	}
</style>
<style scoped>
	.antique{
		background-color: #FFFFFF;
	}
	.rowHover:hover{
		background-color: #E6F7FF !important;
	}
	.orderCol{
		line-height: 35px;
	}
	.darks{
		 filter: grayscale(99%);
		    filter: gray;
		    opacity:0.7
	}
	
</style>
<style type="text/css" scoped>
 
        .table
 
        {
 
            border-collapse: collapse;
 
            margin: 0 auto;
 
            text-align: center;
 
        }
 
        .table td, table th
 
        {
 
            border: 1px solid #cad9ea;
 
            color: #666;
 
            height: 30px;
 
        }
 
        .table thead th
 
        {
 
            background-color: #CCE8EB;
 
            width: 100px;
 
        }
 
        .table tr:nth-child(odd)
 
        {
			
            background: #fff;
 
        }
 
        .table tr:nth-child(even)
 
        {
 
            background: #F5FAFA;
 
        }
	
 
    </style>
